import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import config from '../../config';

import {
    getCars,
    updateInputCar,
    submitUpdatedCar,
    deleteCar,
} from '../../actions/cars_actions';
import {
    updateInputNewCar,
    submitNewCar,
} from '../../actions/new_car_actions';

class EditCars extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            loaded: false,
            edit: {},
        };

        this.submitCar = this.submitCar.bind(this);
        this.renderList = this.renderList.bind(this);
        this.alertRender = this.alertRender.bind(this);
    }

    componentDidMount() {
        this.props.getCars();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            loaded: true,
        });
    }

    submitCar(event) {
        const car = this.props.newCar;

        let valid = true;

        if(!car.name) {
            valid = false;
            let errors = this.state.errors;
            errors.push({ message: "Zadaj názov auta!" });

            this.setState({ errors });
        }

        if(!valid)
            return;

        this.props.submitNewCar(car);
    }

    renderList() {
        const cars = this.props.cars;

        return cars.map(car => {
            const editState = this.state.edit;
            const edit = editState[car.key];

            const saveCar = () => {
                let valid = true;

                if(!car.name) {
                    valid = false;
                    let errors = this.state.errors;
                    errors.push({ message: "Zadaj názov auta!" });

                    this.setState({ errors });
                }

                if(!valid)
                    return;

                let newState = editState;
                newState[car.key] = false;
                this.setState({newState});

                this.props.submitUpdatedCar(car);
            };

            return (
                <tr key={car.key}>
                    <td>{moment(car.dateAdd).locale('sk').format('LLL')}</td>
                    <td>{edit ?
                        <div className="form-group">
                            <input
                                autoFocus
                                type="text"
                                className="form-control"
                                value={car.name}
                                onFocus={(e) => {
                                    e.target.value = e.target.value;
                                }}
                                onChange={event => {
                                    const name = event.target.value;

                                    this.props.updateInputCar({
                                        'name': name,
                                        'key': car.key,
                                    });
                                }}
                                onKeyPress={(event) => {
                                    if (event.key === 'Enter')
                                        saveCar();
                                }}
                            />
                        </div> :
                        car.name}
                    </td>
                    <td>
                        {edit ?
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={saveCar}
                            >
                                Uložiť
                            </button> :
                            <button
                                className="btn btn-default"
                                type="button"
                                onClick={() => {
                                    let newState = editState;
                                    newState[car.key] = true;
                                    this.setState({newState});
                                }}
                            >
                                Editovať
                            </button>
                        }
                        <button
                            className="btn btn-default btn-danger"
                            type="button"
                            onClick={() => {
                                this.props.deleteCar(car.key);
                            }}
                        >
                            Vymazať
                        </button>
                    </td>
                </tr>
            )
        });
    }

    alertRender() {
        if (this.state.errors.length > 0)
            setTimeout(() => {
                this.setState({errors: []})
            }, config.errorTimeout);
    }

    render() {
        const now = moment().locale('sk').format('LLL');

        if(!this.state.loaded)
            return <div className="alert alert-info">Načítam...</div>;

        this.alertRender();

        return (
            <div className="container">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="panel-title">Zoznam vozidiel</h3>
                    </div>
                    <div className="panel-body">
                        {(this.state.errors.length > 0) && (
                            <div className="alert alert-danger">{this.state.errors[0].message}</div>
                        )}
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Datum pridania</th>
                                        <th>Názov vozidla</th>
                                        <th>Akcia</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderList()}
                                    <tr>
                                        <td>{now} (teraz)</td>
                                        <td>
                                            <div className="form-group">
                                                <input
                                                    autoFocus
                                                    type="text"
                                                    className="form-control"
                                                    value={this.props.newCar.name}
                                                    onChange={event => {
                                                        const data = event.target.value;

                                                        const car = {
                                                            "name": data,
                                                        };

                                                        this.props.updateInputNewCar(car);
                                                    }}
                                                    onKeyPress={(event) => {
                                                        if (event.key === 'Enter')
                                                            this.submitCar();
                                                    }}
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <button
                                                className="btn btn-default btn-primary"
                                                onClick={this.submitCar}
                                                type="button"
                                            >
                                                Pridať
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCars,
        updateInputCar,
        submitUpdatedCar,
        deleteCar,
        updateInputNewCar,
        submitNewCar,
    }, dispatch);
}

function mapStateToProps({ cars, newCar }) {
    return {
        cars,
        newCar,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditCars);



// WEBPACK FOOTER //
// ./src/app/components/editCars/editCars.jsx